import { diffWords } from 'diff'
import type { DiffToken } from '../types'

export function computeWordDiff(original: string, redacted: string): DiffToken[] {
  const changes = diffWords(original, redacted)
  return changes.map((change) => ({
    value: change.value,
    added: change.added,
    removed: change.removed,
  }))
}
